import { cn } from "cn"

import { Loading } from "./ui/loading"
import { Portal } from "./ui/portal"

export function LoadingPageIndicator({ isLoading }: { isLoading: boolean }) {
  return (
    <Portal>
      <div className="pointer-events-none fixed bottom-9 left-1/2 z-2 -translate-x-1/2 sm:left-[calc(50%+(var(--nav-width)/2))]">
        <div
          className={cn(
            "flex h-10 items-center justify-center rounded-full bg-background/80 px-4 shadow-xl backdrop-blur-xs transition-[transform,opacity]",
            !isLoading && "translate-y-3 opacity-0"
          )}
        >
          <Loading />
        </div>
      </div>
    </Portal>
  )
}
